// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 4.5C13.2426 4.5 14.25 3.49264 14.25 2.25C14.25 1.00736 13.2426 0 12 0C10.7574 0 9.75 1.00736 9.75 2.25C9.75 3.49264 10.7574 4.5 12 4.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.75 7V5.5H2.25V7L8.75 8.75L9 12L4.75 22.75L6.25 23.5L11.995 14.5H12.005L17.75 23.5L19.25 22.75L15 12L15.25 8.75L21.75 7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-accessibility-filled')
export default class AccessibilityFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'accessibility-filled',
    }
  }
}
